export default "__VITE_ASSET__8f096c02__"